import { render, staticRenderFns } from "./OverviewSidebar.vue?vue&type=template&id=2cf20f5c&scoped=true&"
import script from "./OverviewSidebar.vue?vue&type=script&lang=ts&"
export * from "./OverviewSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewSidebar.vue?vue&type=style&index=0&id=2cf20f5c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf20f5c",
  null
  
)

export default component.exports